// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1Dl6F","form":"styles_form__1ldcp"};